import _ from "underscore";
import uniqid from 'uniqid';
import moment from "moment"
export function getDiagRef(index) {
  switch (index) {
    case 1:
      return "A";
    case 2:
      return "B";
    case 3:
      return "C";
    case 4:
      return "D";
    case 5:
      return "E";
    default:
      break;
  }
}

export function getTotalCharge(newClaim, index) {
  if (index === 1) {
    return parseFloat(newClaim["charge_" + index]);
  } else {
    return (
      (parseFloat(newClaim["total_charge"]) + parseFloat(newClaim["charge_" + index])).toFixed(2)
    );
  }
}

export function mergeLineItems(data, fileName, provider_info) {
  const groupedData = _.groupBy(data, function (item) {
    return item.ins_number + item.date_of_service.replace(/\//g, "");
  });
  let mergedData = [];
  const batchID = uniqid('batch').toUpperCase();

  _.each(groupedData, matchedClaims => {
    let newClaim = {};
    _.each(matchedClaims, (claim, index) => {
      index++;

      newClaim["accept_assign"] = "Y";
      newClaim["bill_addr_1"] = provider_info.company_billing_address;
      newClaim["bill_addr_2"] = provider_info.company_billing_address_2;
      newClaim["bill_city"] = provider_info.company_city;
      newClaim["bill_id"] = provider_info.company_billing_id;
      newClaim["bill_name"] = provider_info.company_name;
      newClaim["bill_npi"] = provider_info.company_billing_npi;
      newClaim["bill_phone"] = provider_info.company_phone;
      newClaim["bill_state"] = provider_info.company_state;
      newClaim["bill_taxid_type"] = "E";
      newClaim["bill_taxid"] = provider_info.company_billing_tax_id;
      newClaim["bill_zip"] = provider_info.company_zip;
      newClaim["charge_" + index] = claim.charge;
      newClaim["diag_" + index] = "R69";
      newClaim["diag_ref_" + index] = "A";
      newClaim["error"] = [];
      newClaim["file_name"] = fileName;
      newClaim["from_date_" + index] = moment(claim.date_of_service).format("MM/DD/YY");
      newClaim["ins_number"] = claim.ins_number;
      newClaim["line_items"] = index;
      newClaim["mod1_" + index] = claim.modifier === "" ? null : claim.modifier;
      newClaim["pat_addr_1"] = claim.pat_add;
      newClaim["pat_addr_2"] = null
      newClaim["pat_city"] = claim.pat_city;
      newClaim["pat_dob"] = moment(claim.pat_dob).format("MM/DD/YY");
      newClaim["pat_name_f"] = claim.pat_name_first;
      newClaim["pat_name_l"] = claim.pat_name_last;
      newClaim["pat_rel"] = "18";
      newClaim["pat_sex"] = claim.pat_sex;
      newClaim["pat_state"] = claim.pat_state;
      newClaim["pat_zip"] = claim.pat_zip;
      newClaim["payerid"] = claim.payer_id;
      newClaim["payer_name"] = getPayerName(provider_info, claim.payer_id)
      newClaim["pcn"] = claim.ins_number;
      newClaim["place_of_service_" + index] = "99";
      newClaim["prior_auth"] = claim.prior_auth;
      newClaim["proc_code_" + index] = claim.procedure_code;
      newClaim["remote_batchid"] = batchID;
      newClaim["remote_claimid"] = uniqid('claim').toUpperCase();
      newClaim["status"] = "Ready";
      newClaim["resubmission_code"] = null;
      newClaim["orig_claim_ref"] = null;
      newClaim["submission_count"] = 0;
      if (claim.payer_id.trim() === "11315") {
        newClaim["pickup_addr_1"] = claim.pickup_addr_1;
        newClaim["pickup_addr_2"] = claim.pickup_addr_2 || null;
        newClaim["pickup_city"] = claim.pickup_city;
        newClaim["pickup_state"] = claim.pickup_state;
        newClaim["pickup_zip"] = claim.pickup_zip;
        newClaim["dropoff_addr_1"] = claim.dropoff_addr_1;
        newClaim["dropoff_addr_2"] = claim.dropoff_addr_2 || null;
        newClaim["dropoff_city"] = claim.dropoff_city;
        newClaim["dropoff_state"] = claim.dropoff_state;
        newClaim["dropoff_zip"] = claim.dropoff_zip;
      }
      newClaim["total_charge"] = getTotalCharge(newClaim, index);
      newClaim["units_" + index] = claim.units;
      newClaim["claimLog"] = {
        claimLog_id: newClaim["remote_claimid"],
        last_updated: moment().toDate(),
        logs: [
          {
            status: "A",
            timestamp: moment().format(),
            entity: "Kinetik",
            message: {
              fields: "",
              mesgid: "ACK",
              message: "Claim uploaded in file: " + fileName,
              status: "A"
            }
          }
        ]
      };
    });
    mergedData.push(newClaim);
  });
  return mergedData;
}



export const readyAllCheck = claims => {
  let errClaims = [];
  let errClaimsIDs = [];
  _.each(claims, claim => {
    let errObj = {
      claim_id: claim.remote_claimid,
      error: []
    };
    _.each(claim, (val, key) => {
      if (val === undefined) return -1;
      if (
        val !== null &&
        val.toString().trim() === "" &&
        key !== "bill_id" &&
        key !== "mod1_1" &&
        key !== "prior_auth" &&
        key !== "error"
      ) {
        errObj.error.push({
          _attributes: {
            fields: key,
            mesgid: "NULL",
            message: key + " cannot be empty",
            status: "R"
          }
        });
      }
    });
    if (errObj.error.length !== 0) {
      errClaims.push(errObj);
      errClaimsIDs.push(claim.remote_claimid);
    }
  });
  return [errClaims, errClaimsIDs];
};

// "_attributes": {
//   "fields": "units_1",
//   "mesgid": "PH218-01",
//   "message": "Number of Units cannot be zero",
//   "status": "R"
// }

const getPayerName = (provider_info, payer_id) => {
  const payers = provider_info.company_payers
  _.each(payers, payer => {
    if (payer.value === payer_id) {
      return payer.label
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/utilities/submit_claims_functions.js